import { Branding } from './model'

/**
 * The organization's picture for a half-screen brand panel: the tall photo
 * made for it, otherwise their banner, otherwise none (their colour alone).
 * A photo fills the panel; a banner is shown whole, since cropping a wide
 * banner into a tall panel cuts its artwork.
 */
export type BrandImage =
	| { kind: 'photo'; fileId: string }
	| { kind: 'banner'; fileId: string }

export const brandImage = (
	branding: Pick<Branding, 'heroPhotoId' | 'heroBannerId'> | undefined
): BrandImage | null => {
	if (branding?.heroPhotoId) {
		return { kind: 'photo', fileId: branding.heroPhotoId }
	}
	if (branding?.heroBannerId) {
		return { kind: 'banner', fileId: branding.heroBannerId }
	}
	return null
}
